import React from 'react'
import { Box, Button, Card, CardContent } from '@mui/material'

import { AppNote, NoDataFound, secondaryButtonSx } from '@components'
import { dsColorNew } from '@palette'
import { analyzerCarPick, analyzerError, analyzerFilters, analyzerUpdating } from 'Pages/AnalyzersV2/@signals'
import { ALL_CARS, emptyText, pickOn } from 'Pages/AnalyzersV2/@services/carPick'
import AnalyzerTableToolbar from 'Pages/AnalyzersV2/@components/Table/Toolbar'


/** The "Updating…" veil of Season over what is on screen while a new answer comes (UX Obs. 1) */
export function UpdatingVeil({ children }) {
	return <Box sx={{ position: 'relative' }}>
		{children}
		{analyzerUpdating.value && <Box sx={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(255,255,255,.55)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', pt: 7.5, zIndex: 6 }}>
			<Box component="span" sx={{ backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '999px', px: 1.75, py: 0.75, fontSize: 13, color: dsColorNew.textMuted, boxShadow: '0 12px 32px rgba(12,26,62,.12)' }}>Updating…</Box>
		</Box>}
	</Box>
}

/**
 * What the price card shows for DOR, LOR and Rank Analyzer once there has been an answer (CU-869fmpqfm, UX Obs. 1):
 * the table under the veil; with a car and no prices, the empty state that says why and "Show all cars"; after an
 * error with a table on screen, a note with "Try again". `veil={false}` when the page veils a wider block (Rank
 * Analyzer: KPIs, verdict and charts too). In the last two the card keeps its header, so the Cars field
 * is always there to get out.
 */
export default function AnalyzerTableState({ noResults, onPick, isPosition = false, veil = true, children }) {
	const pick = analyzerCarPick.value
	const error = analyzerError.value
	const empty = noResults && pickOn(pick)
	if (!error && !empty) return veil ? <UpdatingVeil>{children}</UpdatingVeil> : children

	const filters = analyzerFilters.value || {}
	const text = empty ? emptyText({ pick, band: { acriss: filters.acriss, categories: filters.categoryID } }) : null
	const Veil = veil ? UpdatingVeil : React.Fragment
	return <Card data-tour-id="tour-price-table">
		<CardContent>
			<AnalyzerTableToolbar isPosition={isPosition} carPick={{ onPick }}/>
			<Veil>
				{error
					? <AppNote severity="error" sx={{ my: 1 }}>
						<b>Could not load the prices.</b> The server did not answer in time. Your car is kept: try again in a moment.
						<Box sx={{ mt: 1 }}><Button variant="outlined" onClick={error.retry} sx={secondaryButtonSx}>Try again</Button></Box>
					</AppNote>
					: <Box sx={{ py: 2 }}>
						<NoDataFound title={text.title} text={text.text}/>
						<Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5 }}>
							<Button variant="outlined" onClick={() => onPick(ALL_CARS)} sx={secondaryButtonSx}>Show all cars</Button>
						</Box>
					</Box>}
			</Veil>
		</CardContent>
	</Card>
}
